import { AbstractControl, ValidationErrors } from '@angular/forms';

export const ABHA_ADDRESS_MIN_LENGTH = 8;
export const ABHA_ADDRESS_MAX_LENGTH = 18;

const ALLOWED_CHARACTERS = /^[A-Za-z0-9][A-Za-z0-9._]*[A-Za-z0-9]$/;
const HANDLE_SEPARATOR = '@';

// ABHA address policy (NHA M1 CRT_ABHA_112): 8 to 18 characters, letters and digits, at most
// one dot and one underscore, neither at the start or the end. The server applies the same rule.
export function isValidAbhaAddress(localPart: string): boolean {
  if (localPart.length < ABHA_ADDRESS_MIN_LENGTH || localPart.length > ABHA_ADDRESS_MAX_LENGTH) {
    return false;
  }

  return ALLOWED_CHARACTERS.test(localPart) && countOf(localPart, '.') <= 1 && countOf(localPart, '_') <= 1;
}

export function abhaAddressValidator(control: AbstractControl): ValidationErrors | null {
  const localPart = String(control.value).trim();
  if (!localPart || isValidAbhaAddress(localPart)) {
    return null;
  }

  return { abhaAddressPolicy: true };
}

// ABDM may suggest an address with or without its @ handle; the form holds the part before it.
export function withoutAbhaHandle(abhaAddress: string): string {
  return abhaAddress.split(HANDLE_SEPARATOR)[0];
}

function countOf(text: string, character: string): number {
  return text.split(character).length - 1;
}
